import React, { useEffect, useState } from 'react'
import OoredooLogo from '../../../assets/images/Ooredoo_logo.png'
import logoNacer from '../../../assets/images/logo-nacer.webp'
import OoredooKpis from '../../../assets/images/OoredooGif.gif'
import getStartedImage from '../../../assets/images/getStartedImage.gif'
import Footer from '../../Footer/Footer'
import { BiArrowBack, BiGlobe, BiMobile, BiCheckCircle } from 'react-icons/bi'
import {
  FiFigma,
  FiLayers,
  FiTarget,
  FiTrendingUp,
  FiUsers,
} from 'react-icons/fi'

const Ooredoo = () => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    import('./projects.css')
      .then(() => setLoading(false))
      .catch(() => setLoading(false))
  }, [])

  const achievements = [
    { icon: <BiMobile size={24} />, metric: '2', label: 'Mobile/Web' },
    { icon: <BiGlobe size={24} />, metric: '3', label: 'Languages (EN/FR/AR)' },
    {
      icon: <FiUsers size={24} />,
      metric: '2M+',
      label: 'Monthly Active Users',
    },
    { icon: <FiLayers size={24} />, metric: '50+', label: 'Design Components' },
  ]

  const keyProjects = [
    {
      title: 'Multilingual UX Overhaul',
      description:
        'Created cohesive experience across English, French, and Arabic with proper RTL considerations',
      impact: 'Improved user engagement across all language segments',
    },
    {
      title: 'Scalable Design System',
      description:
        'Built comprehensive component library with clear usage guidelines',
      impact:
        'Reduced design-to-development time and ensured brand consistency',
    },
    {
      title: 'User-Centered Feature Development',
      description: 'Implemented user research insights into design decisions',
      impact: 'Enhanced feature adoption rates and user satisfaction',
    },
  ]

  const skillsUsed = [
    {
      icon: <FiFigma size={20} />,
      skill: 'Advanced Figma',
      description: 'Component systems, prototyping',
    },
    {
      icon: <FiLayers size={20} />,
      skill: 'Design Systems',
      description: 'Scalable architecture, documentation',
    },
    {
      icon: <BiGlobe size={20} />,
      skill: 'Cross-Cultural Design',
      description: 'Multi-language, RTL layouts',
    },
    {
      icon: <FiTarget size={20} />,
      skill: 'User Research',
      description: 'Behavioral analysis, accessibility',
    },
  ]

  return (
    <div>
      {loading ? (
        <div class="spinner-wrap">
          <div className="loading-container">
            <img className="logo-on-loading" src={logoNacer} alt="" />
            <div class="spinner-item"></div>
            <div class="spinner-item spinner-item--2"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="bg-black font-sans overflow-hidden">
            <header class="header">
              <a href="https://nacermediouni.vercel.app/">
                <img class="logo" src={logoNacer} alt="" />
              </a>
            </header>
            <div className="absolute flex flex-col z-[9999] top-11 right-6 md:right-12 w-fit h-fit">
              <a
                className=" flex gap-4 items-center text-sm font-bold  text-white hover:text-neutral-500 "
                href="https://nacer-mediouni.netlify.app/works"
              >
                <BiArrowBack size={20} />
                Back to projects
              </a>
              <span className="relative left-10 bottom-3 rotate-90 w-[1px] h-10 bg-[#00ffc6]"></span>
            </div>

            {/* Enhanced Hero Section */}
            <div className="w-full h-screen bg-[url('/src/assets/images/OoredooCover.webp')] bg-no-repea bg-cover lg:bg-fixed  bg-center ">
              <div className="absolute inset-0 z-10 w-full h-screen bg-black/80 backdrop-blur-sm ">
                <div className="w-full h-full flex flex-col items-center justify-end gap-6 pb-[50%] md:pb-[15%]">
                  <img
                    src={OoredooLogo}
                    alt="Ooredoo-project-logo"
                    className="w-1/2 lg:w-[20%]"
                  />
                  <div className="text-center space-y-4">
                    <h1 className="text-xl lg:text-3xl mx-6 lg:mx-0 font-bold text-white my-2">
                      Transforming digital experience for 2M+ users
                    </h1>
                    <p className="mx-4 lg:mx-[15%] text-base lg:text-xl text-center font-medium text-neutral-200">
                      Leading the redesign of Tunisia's premier
                      telecommunications app, serving over two million monthly
                      active users across diverse linguistic communities.
                    </p>
                  </div>
                  <div className="w-full absolute bottom-10">
                    <div class="scd">
                      <div class="chv"></div>
                      <div class="chv"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Project Info Section - Original Layout */}
            <div className="w-full h-full py-10 px-[10%] md:px-[20%] bg-slate-50 text-black ">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Role</h1>
                  <span className="text-base font-medium">
                    Senior UX/UI Product Design Consultant
                  </span>
                </div>
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Timeline</h1>
                  <span className="text-base font-medium">
                    Mar 2024 - Jan 2025
                  </span>
                  <span className="text-sm text-neutral-500">
                    12 months, Full-time
                  </span>
                </div>
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Impact</h1>
                  <span className="text-base font-medium">
                    2M+ Monthly Users
                  </span>
                  <span className="text-sm text-neutral-500">
                    Tunisia's #1 Telecom App
                  </span>
                </div>
              </div>

              {/* Team Context */}
              <div className="mt-8 p-6 bg-white rounded-lg shadow-sm">
                <h2 className="text-xl font-bold mb-3">Team Settings</h2>
                <p className="text-sm xl:text-base text-neutral-600">
                  Collaborated within Digital & Marketing department with
                  Marketing specialists, Software Engineers, Mobile Developers,
                  Product Managers, Growth Hackers, and international external
                  agencies to deliver cohesive solutions.
                </p>
              </div>
            </div>

            {/* Achievements Metrics Section - White Background */}
            <div className="w-full py-16 px-[10%] md:px-[20%] bg-white">
              <div className="mx-auto">
                <h2 className="text-2xl md:text-3xl font-bold text-center mb-4 text-neutral-800">
                  Impact & Scale
                </h2>
                <p className="text-center text-neutral-600 mb-12 max-w-2xl mx-auto">
                  Transforming digital experience for millions of users across
                  Tunisia's leading telecommunications platform
                </p>

                <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
                  {achievements.map((achievement, index) => (
                    <div
                      key={index}
                      className="bg-neutral-50 rounded-xl p-6 text-center hover:shadow-lg transition-all duration-300 hover:transform hover:-translate-y-1"
                    >
                      <div className="flex justify-center mb-4 text-neutral-700">
                        {achievement.icon}
                      </div>
                      <div className="text-2xl md:text-3xl font-bold text-neutral-800 mb-2">
                        {achievement.metric}
                      </div>
                      <div className="text-sm text-neutral-600 font-medium leading-tight">
                        {achievement.label}
                      </div>
                    </div>
                  ))}
                </div>

                {/* Additional Key Metrics */}
                <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-gradient-to-r from-neutral-50 to-neutral-100 rounded-xl p-6">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 bg-neutral-800 rounded-full flex items-center justify-center">
                        <BiMobile className="text-white" size={24} />
                      </div>
                      <div>
                        <div className="text-2xl font-bold text-neutral-800">
                          9M+
                        </div>
                        <div className="text-sm text-neutral-600 font-medium">
                          App Downloads
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gradient-to-r from-neutral-50 to-neutral-100 rounded-xl p-6">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 bg-neutral-800 rounded-full flex items-center justify-center">
                        <FiTarget className="text-white" size={24} />
                      </div>
                      <div>
                        <div className="text-2xl font-bold text-neutral-800">
                          #1
                        </div>
                        <div className="text-sm text-neutral-600 font-medium">
                          Telecom App in Tunisia
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Content Section */}
            <div className="w-full h-full pb-10 px-[10%] md:px-[20%] bg-white text-neutral-600 ">
              <div className="w-full flex justify-between items-center flex-wrap gap-4">
                <div className="w-full text-center">
                  <h1 className="text-3xl md:text-5xl font-extrabold">
                    Ooredoo Tunisia
                  </h1>
                  <h1 className="text-base md:text-xl font-extrabold my-2">
                    #1 Most used Tunisian utility Mobile App & Website
                  </h1>
                </div>
              </div>

              <img
                src={OoredooKpis}
                className="w-full my-10 rounded-3xl border-[1px] border-neutral-100"
                alt="ooredoo-project-showcase"
              />

              {/* The Challenge Section */}
              <div className="my-20">
                <div className=" mx-auto">
                  <h2 className="text-2xl md:text-3xl font-bold mb-6 text-neutral-800">
                    The Challenge
                  </h2>
                  <p className="text-base md:text-lg leading-relaxed text-neutral-600 mb-8">
                    Ooredoo Tunisia needed to modernize their digital experience
                    to maintain market leadership in Tunisia's competitive
                    telecom landscape. The existing app required enhanced user
                    experience for a diverse, multilingual user base, consistent
                    design language across multiple platforms, and scalable
                    design infrastructure for future growth.
                  </p>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="bg-neutral-50 border border-neutral-200 rounded-xl p-6 hover:shadow-md transition-shadow duration-300">
                      <h3 className="font-bold text-lg mb-4 text-neutral-800">
                        User Experience Challenges
                      </h3>
                      <ul className="space-y-3">
                        <li className="flex items-start gap-3">
                          <div className="w-2 h-2 bg-neutral-400 rounded-full mt-2 flex-shrink-0"></div>
                          <span className="text-sm text-neutral-600">
                            Multilingual support (EN/FR/AR)
                          </span>
                        </li>
                        <li className="flex items-start gap-3">
                          <div className="w-2 h-2 bg-neutral-400 rounded-full mt-2 flex-shrink-0"></div>
                          <span className="text-sm text-neutral-600">
                            Cultural design considerations
                          </span>
                        </li>
                        <li className="flex items-start gap-3">
                          <div className="w-2 h-2 bg-neutral-400 rounded-full mt-2 flex-shrink-0"></div>
                          <span className="text-sm text-neutral-600">
                            Accessibility standards compliance
                          </span>
                        </li>
                      </ul>
                    </div>

                    <div className="bg-neutral-50 border border-neutral-200 rounded-xl p-6 hover:shadow-md transition-shadow duration-300">
                      <h3 className="font-bold text-lg mb-4 text-neutral-800">
                        Technical Requirements
                      </h3>
                      <ul className="space-y-3">
                        <li className="flex items-start gap-3">
                          <div className="w-2 h-2 bg-neutral-400 rounded-full mt-2 flex-shrink-0"></div>
                          <span className="text-sm text-neutral-600">
                            Cross-platform consistency
                          </span>
                        </li>
                        <li className="flex items-start gap-3">
                          <div className="w-2 h-2 bg-neutral-400 rounded-full mt-2 flex-shrink-0"></div>
                          <span className="text-sm text-neutral-600">
                            Scalable design system
                          </span>
                        </li>
                        <li className="flex items-start gap-3">
                          <div className="w-2 h-2 bg-neutral-400 rounded-full mt-2 flex-shrink-0"></div>
                          <span className="text-sm text-neutral-600">
                            Performance optimization
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Role & Approach Section */}
              <div className="my-20">
                <div className=" mx-auto">
                  <h2 className="text-2xl md:text-3xl font-bold mb-6 text-neutral-800">
                    My Role & Approach
                  </h2>
                  <p className="text-base md:text-lg leading-relaxed text-neutral-600 mb-8">
                    As the lead UX/UI consultant, I spearheaded the complete
                    redesign initiative, working directly with product managers,
                    developers, and marketing teams to deliver a cohesive
                    digital ecosystem that serves over 2 million monthly active
                    users.
                  </p>

                  <div className="flex flex-wrap xl:flex-nowrap w-full justify-start items-start xl:gap-24 gap-10 ">
                    <div className="space-y-6 w-fit">
                      <h3 className="text-xl font-bold text-neutral-800">
                        Key Responsibilities
                      </h3>
                      <div className="space-y-4">
                        <div className="flex items-start gap-4">
                          <BiCheckCircle
                            className="text-green-600 mt-1 flex-shrink-0"
                            size={20}
                          />
                          <div className="flex flex-col">
                            <span className="font-semibold truncate text-neutral-800 text-base xl:text-lg">
                              Strategic Design Leadership:
                            </span>
                            <span className="text-neutral-600 text-sm xl:text-base">
                              Guided design decisions for Tunisia's leading
                              telecom app
                            </span>
                          </div>
                        </div>
                        <div className="flex items-start gap-4">
                          <BiCheckCircle
                            className="text-green-600 mt-1 flex-shrink-0"
                            size={20}
                          />
                          <div className="flex flex-col">
                            <span className="font-semibold text-neutral-800 text-base xl:text-lg">
                              Cross-Cultural Design:
                            </span>
                            <span className="text-neutral-600 text-sm xl:text-base">
                              Created inclusive experiences with proper RTL
                              considerations
                            </span>
                          </div>
                        </div>
                        <div className="flex items-start gap-4">
                          <BiCheckCircle
                            className="text-green-600 mt-1 flex-shrink-0"
                            size={20}
                          />
                          <div className="flex flex-col">
                            <span className="font-semibold text-neutral-800 text-base xl:text-lg">
                              System Architecture:
                            </span>
                            <span className="text-neutral-600 text-sm xl:text-base">
                              Built comprehensive design system for consistency
                            </span>
                          </div>
                        </div>
                        <div className="flex items-start gap-4">
                          <BiCheckCircle
                            className="text-green-600 mt-1 flex-shrink-0"
                            size={20}
                          />
                          <div className="flex flex-col">
                            <span className="font-semibold text-neutral-800 text-base xl:text-lg">
                              Collaborative Innovation:
                            </span>
                            <span className="text-neutral-600 text-sm xl:text-base">
                              Aligned user needs with business objectives
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="space-y-6 w-fit">
                      <h3 className="text-xl font-bold text-neutral-800">
                        Technical Expertise
                      </h3>
                      <div className="flex flex-col gap-6 items-start justify-start ">
                        {skillsUsed.map((skill, index) => (
                          <div
                            key={index}
                            className="flex items-start gap-4 rounded-lg "
                          >
                            <div className="text-neutral-700 mt-1">
                              {skill.icon}
                            </div>
                            <div>
                              <div className="font-semibold text-neutral-800 text-base xl:text-lg">
                                {skill.skill}
                              </div>
                              <div className="text-sm text-neutral-600">
                                {skill.description}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Key Projects Section */}
              <div className="my-20">
                <div className="mx-auto">
                  <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center text-neutral-800">
                    Key Projects & Solutions
                  </h2>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {keyProjects.map((project, index) => (
                      <div
                        key={index}
                        className="bg-white border border-neutral-200 rounded-xl p-6 hover:shadow-lg hover:border-neutral-300 transition-all duration-300"
                      >
                        <div className="mb-4">
                          <div className="w-10 h-10 bg-neutral-100 rounded-lg flex items-center justify-center mb-4">
                            <span className="text-neutral-600 font-bold">
                              {index + 1}
                            </span>
                          </div>
                          <h3 className="font-bold xl:text-lg text-neutral-800 mb-3">
                            {project.title}
                          </h3>
                        </div>

                        <p className="text-neutral-600 mb-6 text-sm xl:text-base leading-relaxed">
                          {project.description}
                        </p>

                        <div className="pt-4 border-t border-neutral-100">
                          <div className="flex items-start gap-3">
                            <FiTrendingUp
                              className="text-green-600 mt-1 flex-shrink-0"
                              size={16}
                            />
                            <span className="text-sm font-medium text-green-700">
                              {project.impact}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Business Value Section */}
              <div className="my-20">
                <div className=" mx-auto">
                  <div className="bg-gradient-to-r from-neutral-50 to-neutral-100 border border-neutral-200 rounded-2xl p-8">
                    <h2 className="text-2xl font-bold mb-8 text-start text-neutral-800">
                      Business Value Delivered
                    </h2>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                      <div className="space-y-4">
                        <h3 className="text-lg font-bold text-neutral-800 flex items-center gap-2">
                          For Ooredoo Tunisia
                        </h3>
                        <ul className="space-y-3">
                          {[
                            "Enhanced competitive position in Tunisia's telecom market",
                            'Improved user retention through better digital experience',
                            'Scalable design infrastructure supporting future growth',
                            'Reduced development costs through systematic design',
                          ].map((item, index) => (
                            <li key={index} className="flex items-start gap-3">
                              <div className="w-1.5 h-1.5 bg-neutral-400 rounded-full mt-2 flex-shrink-0"></div>
                              <span className="text-neutral-600 text-sm xl:text-base">
                                {item}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="space-y-4">
                        <h3 className="text-lg font-bold text-neutral-800 flex items-center gap-2">
                          For 2M+ Users
                        </h3>
                        <ul className="space-y-3">
                          {[
                            'Streamlined access to telecom services',
                            'Culturally appropriate and accessible interface',
                            'Consistent experience across all touchpoints',
                            'Improved task completion rates and satisfaction',
                          ].map((item, index) => (
                            <li key={index} className="flex items-start gap-3">
                              <div className="w-1.5 h-1.5 bg-neutral-400 rounded-full mt-2 flex-shrink-0"></div>
                              <span className="text-neutral-600 text-sm xl:text-base">
                                {item}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* What This Demonstrates */}
              <div className="my-20">
                <div className=" mx-auto">
                  <h2 className="text-2xl font-bold mb-8 text-start text-neutral-800">
                    What this experience demonstrates
                  </h2>

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {[
                      'Scale: 2M+ user application',
                      'Complexity: Multilingual design',
                      'Leadership: Enterprise environment',
                      'Systems Thinking: Scalable infrastructure',
                      'Cultural Competency: Diverse users',
                      'Business Acumen: Industry alignment',
                    ].map((item, index) => (
                      <div
                        key={index}
                        className="flex items-center gap-3 p-4 bg-green-50 border border-green-200 rounded-lg hover:bg-green-100 transition-colors duration-200"
                      >
                        <BiCheckCircle
                          className="text-green-600 flex-shrink-0"
                          size={18}
                        />
                        <span className="text-sm font-medium text-green-800">
                          {item}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Added notice section */}
              <div className="w-full my-10 p-6 bg-neutral-100 rounded-lg">
                <h2 className="text-xl font-bold mb-2">
                  Confidentiality Notice
                </h2>
                <p className="text-neutral-600 text-sm xl:text-base">
                  Due to confidentiality agreements with Ooredoo, some recent
                  telecom projects and specific details about my work cannot be
                  shared publicly. For more information about my contributions,
                  please contact me directly.
                </p>
              </div>

              <div className="w-full text-center mx-auto my-10">
                <a
                  href="/works"
                  rel="noopener noreferrer"
                  className=" text-sm lg:text-base text-neutral-800 font-medium underline"
                >
                  ← Back to projects
                </a>
              </div>
            </div>

            {/* CTA Section */}
            <div className=" bg-black flex flex-col md:flex-row justify-start items-center ">
              <img
                src={getStartedImage}
                alt="get started"
                className="w-[50%]"
              />
              <div className="w-full h-full gap-10 flex flex-col justify-center items-center md:items-start mx-auto pb-20 md:pb-0">
                <p className="text-3xl lg:text-5xl md:w-[90%] px-[10%] md:px-0 text-center md:text-start font-semibold">
                  Want to build remarkable products together?
                </p>
                <a
                  href="https://www.linkedin.com/in/nacermediouni/"
                  aria-label="Linkedin"
                  target="_blank"
                  rel="noreferrer"
                  className=" text-2xl lg:text-3xl text-[#00ffc6] font-bold underline underline-offset-2 hover:underline-offset-1"
                >
                  Let's get started!
                </a>
              </div>
            </div>

            <div className="  w-full flex flex-col justify-center items-center pt-20 pb-8 px-[10%] md:px-[20%] font-sans bg-white">
              <Footer />
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default Ooredoo
